/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "find"
      }), "(", _jsx(_components.code, {
        children: "find"
      }), ")"]
    }), "\n", _jsx(_components.p, {
      children: "| v3"
    }), "\n", _jsx(_components.p, {
      children: "一种方便的方法，用于在给定 DOM 根中查找样式化组件的渲染 DOM 节点的单个实例。"
    }), "\n", _jsx(_components.p, {
      children: "¥A convenience method to find a single instance of a styled component's rendered DOM node within a given DOM root."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled from 'styled-components'\nimport { find } from 'styled-components/test-utils'\n\nconst Foo = styled.div`\n  color: red;\n`\n\n/**\n\n * Somewhere in your app:\n\n *  * ReactDOM.render(\n\n *   <main>\n\n *     <Foo />\n\n *   </main>, document.body\n\n * );\n */\n\n// retrieves the first instance of \"Foo\" in the body (querySelector under the hood)\nfind(document.body, Foo) // HTMLDivElement | null\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
